import React from 'react';
import { IIconProps } from './utils';

export const ReadingCheck = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M3.75 6.25C3.75 3.48858 5.98858 1.25 8.75 1.25H23.75C25.1307 1.25 26.25 2.36929 26.25 3.75V26.25C26.25 27.6307 25.1307 28.75 23.75 28.75H8.75C7.04067 28.75 5.74721 28.1131 4.89772 27.1295C4.07913 26.1817 3.75 25.0028 3.75 24V12.5C3.75 11.8096 4.30964 11.25 5 11.25C5.69036 11.25 6.25 11.8096 6.25 12.5V20.2088C6.95991 19.9057 7.79836 19.75 8.75 19.75H23.75V3.75H8.75C7.36929 3.75 6.25 4.86929 6.25 6.25V7.5C6.25 8.19036 5.69036 8.75 5 8.75C4.30964 8.75 3.75 8.19036 3.75 7.5V6.25ZM23.75 22.25H8.75C7.59926 22.25 7.00383 22.5604 6.70343 22.8449C6.40346 23.1291 6.25 23.5265 6.25 24C6.25 24.4972 6.42087 25.0683 6.78978 25.4955C7.12779 25.8869 7.70933 26.25 8.75 26.25H23.75V22.25Z"
      fill={fill}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M20.8621 7.59483C21.362 8.07094 21.3813 8.86216 20.9052 9.36207L14.2385 16.3621C14.0026 16.6098 13.6754 16.75 13.3333 16.75C12.9912 16.75 12.6641 16.6098 12.4282 16.3621L9.09483 12.8621C8.61872 12.3622 8.63802 11.5709 9.13793 11.0948C9.63785 10.6187 10.4291 10.638 10.9052 11.1379L13.3333 13.6875L19.0948 7.63793C19.5709 7.13802 20.3622 7.11872 20.8621 7.59483Z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
